import { useState } from "react";
import { FiDownload } from "react-icons/fi";
import { FaChevronDown } from "react-icons/fa";
import { HiOutlineVideoCamera } from "react-icons/hi2";

const DownloadDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => setIsOpen(!isOpen);

    return (
        <div className="relative inline-block text-right">
            <button
                onClick={handleToggle}
                className="flex items-center gap-2 bg-[#0061A8] hover:bg-[#087c93] text-white font-semibold py-2 px-4 rounded-xl transition duration-300"
            >
                <FiDownload className="text-white text-lg" />
                <span className="text-sm">دانلود فایل آموزشی</span>
                <FaChevronDown className="text-xs mt-0.5" />
            </button>

            {isOpen && (
                <div className="absolute z-[100000] mt-2 w-64 bg-white border border-gray-200 rounded-md shadow-lg overflow-hidden">
                    <a
                        href="/videos/guide-tools.mp4"
                        download
                        className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-[#0061A8] hover:font-semibold transition"
                    >
                        <HiOutlineVideoCamera className="text-lg" />
                        نحوه استفاده از ابزارهای سامانه
                    </a>
                    <a
                        href="/videos/guide.mp4"
                        download
                        className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-[#0061A8] hover:font-semibold transition"
                    >
                        <HiOutlineVideoCamera className="text-lg" />
                        نحوه کار با سامانه
                    </a>
                </div>
            )}
        </div>
    );
};

export default DownloadDropdown;
